import "flowbite/dist/flowbite.turbo"
import * as Turbo from "@hotwired/turbo"
import "@hotwired/turbo-rails"
import "@rails/actioncable"

// Custom Turbo Stream actions
Turbo.StreamActions.close_dialog = function () {
  const dialogElement = document.querySelector(
    "dialog[data-dialog-target='dialog']",
  )
  if (dialogElement) {
    dialogElement.close()
  }
}

Turbo.StreamActions.open_dialog = function () {
  const url = this.getAttribute("url")
  const dialogElement = document.querySelector(
    "dialog[data-dialog-target='dialog']",
  )
  const contentFrame = document.querySelector("[data-dialog-target='content']")
  if (dialogElement && contentFrame && url) {
    dialogElement.showModal()
    contentFrame.src = url
  }
}

Turbo.StreamActions.show_dialog = function () {
  const dialogElement = document.querySelector(
    "dialog[data-dialog-target='dialog']",
  )
  if (dialogElement) {
    dialogElement.showModal()
  }
}

Turbo.StreamActions.redirect = function () {
  const url = this.getAttribute("url")
  if (url) {
    Turbo.visit(url)
  }
}

// stimulus controllers
import "./controllers"

import * as ActiveStorage from "@rails/activestorage"

ActiveStorage.start()

import "trix"
import "@rails/actiontext"
